/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type FollowingRefetchWrapper_user$ref = any;
export type FollowingRefetchWrapper_user = {
    readonly favorites: {
        readonly totalResults: number | null;
        readonly edges: ReadonlyArray<{
            readonly cursor: string;
            readonly node: {
                readonly serviceId: string | null;
                readonly page: string | null;
                readonly name: string | null;
                readonly query: string | null;
                readonly type: string | null;
                readonly parameters: ReadonlyArray<{
                    readonly key: string | null;
                    readonly type: string | null;
                    readonly values: ReadonlyArray<string | null> | null;
                } | null> | null;
                readonly items: {
                    readonly edges: ReadonlyArray<{
                        readonly node: {
                            readonly serviceId: string | null;
                            readonly title: string | null;
                            readonly pdpURL: string | null;
                            readonly contemporaryTrackingString: string;
                            readonly categoryPath: string | null;
                            readonly seller: {
                                readonly serviceId: string | null;
                            } | null;
                            readonly pricing: {
                                readonly retailPrice: {
                                    readonly amount: number | null;
                                } | null;
                            } | null;
                            readonly photos: ReadonlyArray<{
                                readonly versions: ReadonlyArray<{
                                    readonly webPath: string | null;
                                } | null> | null;
                            } | null> | null;
                        } | null;
                    } | null> | null;
                } | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": FollowingRefetchWrapper_user$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "FollowingRefetchWrapper_user",
        "type": "User",
        "metadata": {
            "connection": [
                {
                    "count": null,
                    "cursor": "after",
                    "direction": "forward",
                    "path": [
                        "favorites"
                    ]
                }
            ]
        },
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "after",
                "type": "String"
            }
        ],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": "favorites",
                "name": "__FollowingRefetchWrapper_favorites_connection",
                "storageKey": "__FollowingRefetchWrapper_favorites_connection(types:[\"SEARCH\",\"SELLER\",\"DESIGNER\",\"USER_PREFERENCE\"])",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "types",
                        "value": [
                            "SEARCH",
                            "SELLER",
                            "DESIGNER",
                            "USER_PREFERENCE"
                        ]
                    }
                ],
                "concreteType": "favoritesConnection",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "totalResults",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "favoritesEdge",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "cursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Favorite",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "page",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "name",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "query",
                                        "args": null,
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/),
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "parameters",
                                        "storageKey": null,
                                        "args": null,
                                        "concreteType": "Parameters",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "key",
                                                "args": null,
                                                "storageKey": null
                                            },
                                            (v1 /*: any*/),
                                            {
                                                "kind": "ScalarField",
                                                "alias": null,
                                                "name": "values",
                                                "args": null,
                                                "storageKey": null
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "LinkedField",
                                        "alias": null,
                                        "name": "items",
                                        "storageKey": "items(first:12,page:0)",
                                        "args": [
                                            {
                                                "kind": "Literal",
                                                "name": "first",
                                                "value": 12
                                            },
                                            {
                                                "kind": "Literal",
                                                "name": "page",
                                                "value": 0
                                            }
                                        ],
                                        "concreteType": "FavoriteItemsConnection",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "alias": null,
                                                "name": "edges",
                                                "storageKey": null,
                                                "args": null,
                                                "concreteType": "FavoriteItemsEdge",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "LinkedField",
                                                        "alias": null,
                                                        "name": "node",
                                                        "storageKey": null,
                                                        "args": null,
                                                        "concreteType": "Item",
                                                        "plural": false,
                                                        "selections": [
                                                            (v0 /*: any*/),
                                                            {
                                                                "kind": "ScalarField",
                                                                "alias": null,
                                                                "name": "title",
                                                                "args": null,
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "alias": null,
                                                                "name": "pdpURL",
                                                                "args": null,
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "alias": null,
                                                                "name": "contemporaryTrackingString",
                                                                "args": null,
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "kind": "ScalarField",
                                                                "alias": null,
                                                                "name": "categoryPath",
                                                                "args": null,
                                                                "storageKey": null
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "seller",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "Seller",
                                                                "plural": false,
                                                                "selections": [
                                                                    (v0 /*: any*/)
                                                                ]
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "pricing",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "ItemPricing",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "alias": null,
                                                                        "name": "retailPrice",
                                                                        "storageKey": null,
                                                                        "args": null,
                                                                        "concreteType": "FinancialAmount",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "alias": null,
                                                                                "name": "amount",
                                                                                "args": null,
                                                                                "storageKey": null
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                "kind": "LinkedField",
                                                                "alias": null,
                                                                "name": "photos",
                                                                "storageKey": null,
                                                                "args": null,
                                                                "concreteType": "ItemPhoto",
                                                                "plural": true,
                                                                "selections": [
                                                                    {
                                                                        "kind": "LinkedField",
                                                                        "alias": null,
                                                                        "name": "versions",
                                                                        "storageKey": null,
                                                                        "args": null,
                                                                        "concreteType": "ItemPhotoVersion",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "ScalarField",
                                                                                "alias": null,
                                                                                "name": "webPath",
                                                                                "args": null,
                                                                                "storageKey": null
                                                                            }
                                                                        ]
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    },
                                    {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "__typename",
                                        "args": null,
                                        "storageKey": null
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "pageInfo",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "endCursor",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "hasNextPage",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = '682e303b04b7ed75c5847006285544fc';
export default node;
